/* ============================================================
   PDP Wellbeinn Balance — interacciones de las secciones balance-*
   Vanilla JS, sin dependencias. Comportamientos:
   - Carruseles con scroll-snap + dots sincronizados ([data-b-carousel])
   - Flechas prev/next de carrusel ([data-b-prev]/[data-b-next])
   - Galería: thumbs que scrollean al slide ([data-b-thumb])
   - Tabs de la sección app ([data-b-tab] filtra [data-b-tab-panel])
   - Add to cart AJAX del hero, sheet, sticky y upselling (cart de Shopify)
   - Bottom sheet "Pre cart" ([data-b-precart-open] abre [data-b-sheet])
   - Sticky CTA ([data-b-sticky]) visible solo pasada la card de precio
   - Stepper de cantidad ([data-b-qty]) del form de compra del hero
   ============================================================ */
(function () {
  'use strict';

  /* Guarda de carga única: balance-pdp-assets se renderiza en cada sección
     balance-*, así que este script se ejecuta una vez por sección. Sin la
     guarda cada listener se registraba N veces (un clic en "+" sumaba 6 y
     el add to cart mandaba 6 requests). */
  if (window.__balancePdpLoaded) return;
  window.__balancePdpLoaded = true;

  /* Sincroniza dots con la posición de scroll de un carrusel.
     Input: contenedor con [data-b-carousel] y un [data-b-dots] hermano. */
  function initCarousel(root) {
    var track = root.querySelector('[data-b-carousel]');
    var dotsWrap = root.querySelector('[data-b-dots]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (dotsWrap && !dotsWrap.children.length) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', function () { scrollToSlide(i); });
        dotsWrap.appendChild(b);
      });
    }

    function scrollToSlide(i) {
      var el = slides[i];
      if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function activeIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (el, i) {
        var mid = el.offsetLeft - track.offsetLeft + el.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function update() {
      var idx = activeIndex();
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
      // Thumbs de galería (si existen)
      var thumbs = root.querySelectorAll('[data-b-thumb]');
      Array.prototype.forEach.call(thumbs, function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
      root.dispatchEvent(new CustomEvent('b:slide', { detail: { index: idx } }));
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }
    });
    update();

    // Flechas (puede haber varias: la flecha lateral y los botones "+" de los slides)
    root.querySelectorAll('[data-b-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { scrollToSlide(Math.max(0, activeIndex() - 1)); });
    });
    root.querySelectorAll('[data-b-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { scrollToSlide(Math.min(slides.length - 1, activeIndex() + 1)); });
    });

    // Thumbs
    var thumbs = root.querySelectorAll('[data-b-thumb]');
    Array.prototype.forEach.call(thumbs, function (t, i) {
      t.addEventListener('click', function () { scrollToSlide(i); });
    });

    // Zoom: abre la imagen del slide activo a tamaño completo
    var zoom = root.querySelector('[data-b-zoom]');
    if (zoom) {
      zoom.addEventListener('click', function () {
        var img = slides[activeIndex()] && slides[activeIndex()].querySelector('img');
        if (img) window.open(img.currentSrc || img.src, '_blank', 'noopener');
      });
    }
  }

  /* Tabs de la sección app: muestra solo las cards del tab activo. */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-b-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-b-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        root.querySelectorAll('[data-b-tab-panel]').forEach(function (card) {
          card.hidden = card.getAttribute('data-b-tab-panel') !== key;
        });
        var track = root.querySelector('[data-b-carousel]');
        if (track) track.scrollTo({ left: 0 });
      });
    });
  }

  /* Stepper de cantidad (fila nueva del hero, reunión 18/9). Input: contenedor
     [data-b-qty] con los botones -/+ y el <input type="number" name="quantity">.
     Mínimo 1 unidad; los botones no disparan submit (son type="button").
     Nota: el precart y el sticky CTA mandan su propio form con quantity=1
     fijo (no leen este input) — si más adelante deben respetar la cantidad
     elegida acá, hay que sincronizar ese valor antes de sus fetch a cart/add.js. */
  function initQty(root) {
    var input = root.querySelector('[data-b-qty-input]');
    var minus = root.querySelector('[data-b-qty-minus]');
    var plus = root.querySelector('[data-b-qty-plus]');
    if (!input || !minus || !plus) return;

    function clamp(value) {
      var n = parseInt(value, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }

    minus.addEventListener('click', function () {
      input.value = clamp(input.value) - 1 < 1 ? 1 : clamp(input.value) - 1;
    });
    plus.addEventListener('click', function () {
      input.value = clamp(input.value) + 1;
    });
    input.addEventListener('change', function () {
      input.value = clamp(input.value);
    });
  }

  /* Add to cart AJAX. Input: form con [data-b-atc]. Abre el cart drawer
     del tema si existe; si no, redirige al carrito. */
  function initAtc(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_error');
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawerToggle = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"][data-drawer]');
          if (drawerToggle) { drawerToggle.click(); } else { window.location.href = '/cart'; }
        })
        .catch(function () {
          // Si el add falla (ej: sin stock), mandamos al carrito para que Shopify muestre el error
          window.location.href = '/cart';
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        });
    });
  }

  /* Bottom sheet "Pre cart". Input: el [data-b-sheet] (uno por página);
     lo abren los botones [data-b-precart-open] de Benefits, lo cierran el
     backdrop, la X ([data-b-sheet-close]) y la tecla Escape. */
  function initSheet(sheet) {
    var lastFocus = null;
    var closeTimer = null;

    function open() {
      // Si se reabre durante la animación de cierre, cancelamos el ocultado pendiente.
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      lastFocus = document.activeElement;
      sheet.hidden = false;
      // Reflow forzado: el panel tiene que existir en translateY(100%) antes de
      // sumar la clase, si no la transición de entrada no corre.
      void sheet.offsetHeight;
      sheet.classList.add('is-open');
      document.body.classList.add('b-sheet-open');
      var closeBtn = sheet.querySelector('[data-b-sheet-close]:not(.b-sheet__backdrop)');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      sheet.classList.remove('is-open');
      document.body.classList.remove('b-sheet-open');
      var done = function () {
        closeTimer = null;
        if (sheet.classList.contains('is-open')) return; // se volvió a abrir mientras cerraba
        sheet.hidden = true;
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        done();
      } else {
        closeTimer = setTimeout(done, 400); // duración de la transición del panel
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-b-precart-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    sheet.querySelectorAll('[data-b-sheet-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  /* Sticky CTA. Input: [data-b-sticky] con data-b-sticky-watch (selector de
     la card de precio). Se muestra solo cuando esa card ya quedó por encima
     del viewport (scroll pasada la card); se esconde al volver arriba.
     Escucha scroll en window y en el body (en Concept el body es el scroller). */
  function initSticky(bar) {
    var target = document.querySelector(bar.getAttribute('data-b-sticky-watch') || '.b-info');
    if (!target) return;
    var visible = null;
    function check() {
      var passed = target.getBoundingClientRect().bottom < 0;
      if (passed === visible) return;
      visible = passed;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }
    window.addEventListener('scroll', check, { passive: true });
    document.body.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function init() {
    document.querySelectorAll('[data-b-carousel-root]').forEach(initCarousel);
    document.querySelectorAll('[data-b-sheet]').forEach(initSheet);
    document.querySelectorAll('[data-b-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-b-tabs-root]').forEach(initTabs);
    document.querySelectorAll('[data-b-qty]').forEach(initQty);
    document.querySelectorAll('form[data-b-atc]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
